const spreadsheetId = '1ijnYlWjwFvw5-Qtfo1UCMEdaAoD-7Ho_bdDSVtDJYJo';
const zh = 0, en = 1, vn = 2;


gapi.load('client',initClient);

//init gapi
function initClient() {
  let GoogleAuth; // Google Auth object.
  gapi.client.init({
      'apiKey': 'AIzaSyDEt_y6KrtFoa876tecRNQFnLgrdsDaPKE',
      // 'clientId': '217010907616-ep4p90qd18c048k0boa9jfq624opctig.apps.googleusercontent.com',
      'scope': 'https://www.googleapis.com/auth/spreadsheets',
      'discoveryDocs': ['https://sheets.googleapis.com/$discovery/rest?version=v4']
  }).then(function () {
    // GoogleAuth = gapi.auth2.getAuthInstance();
    // Listen for sign-in state changes.
    // GoogleAuth.isSignedIn.listen((isSignedIn) => isSignedIn ? startBuild() : GoogleAuth.signIn());
    // GoogleAuth.isSignedIn.get() ? startBuild() : GoogleAuth.signIn();
    startBuild();
  });
}

// watch num
// if u need debug, open it
// document.addEventListener("click", updateNum);
// function updateNum() {
//   document.querySelector(".currentCategory").innerText = currentCategory;
//   document.querySelector(".currentPage").innerText = currentPage;
// }

// check breakpoint
function isMobile() {
  let mql = window.matchMedia('(max-width: 768px), (max-width: 480px)');
  return mql.matches;
}

var resizeId, device = isMobile();
window.addEventListener('resize', function() {
  clearTimeout(resizeId);
  resizeId = setTimeout(myRefresh, 200);
});

// try to use this fix the mess, caz we need to set gridTemplateAreas style when category click
function myRefresh() {
  if (device != isMobile()) {
    window.location.reload();
  }
}

let data = [], currentData = [];
let currentCategory = 0, currentPage = 0;
let prevPageLanguage = document.referrer.substring(22, 24);
window.data = data;
// get spreadsheet's info
function startBuild() {
  let request = gapi.client.sheets.spreadsheets.values.get({spreadsheetId: spreadsheetId, range: '版型家族'});
  request.then(function(response) {
    response.result.values.shift();
    return response.result.values;
  }, function(reason) {
    console.error('error: ' + reason.result.error.message);
  }).then(function(list) {
    let requestArr = [];
    list.forEach((item, index) => {
      let request = gapi.client.sheets.spreadsheets.values.get({spreadsheetId: spreadsheetId, range: item[0]});
      requestArr.push(request.then(function(response) {
        let ads = [];
        response.result.values.forEach((el) => {
          let ad = {
            zh: {
              typeName: el[0],
              device: el[4],
              safe: el[5],
              link: el[6],
              material: el[7],
              note: (el[8] || "").trim(),
              memo: (el[9] || "").trim(),
              demoVideo: el[10],
              galleryLink: (el[11] || "").trim(),
            },
            en: {
              typeName: el[13],
              device: el[14],
              safe: el[15],
              link: el[16],
              material: el[17],
              note: (el[18] || "").trim(),
              memo: (el[19] || "").trim(),
              demoVideo: el[20],
              galleryLink: (el[21] || "").trim()
            },
            vn: {
              typeName: el[13],
              device: el[23],
              safe: el[24],
              link: el[25],
              material: el[26],
              note: (el[27] || "").trim(),
              memo: (el[28] || "").trim(),
              demoVideo: el[20],
              galleryLink: (el[21] || "").trim()
            },
            adType: el[1].split(".")[1],
            adDevice: el[2],
            switchGroup: el[3]
          };
          ads.push(ad);
        });
        let name = response.result.range.split("!")[0];
        name = name.substring(1, name.length - 1);
        img = item[1];
        enName = item[3];
        vnName = item[4];
        ads.shift();
        data[index] = {name: name, img: img, ads: ads, enName: enName, vnName: vnName};
      }));
    });
    return Promise.all(requestArr);
  }).then(myOnload);
}

let flag, img, video, imgVideo, hr, opImg, opVideo, opImgVideo;
function myOnload() {
  // initial list menu option
  flag = document.querySelector('#flag');
  img = document.querySelector('#img');
  video = document.querySelector('#video');
  imgVideo = document.querySelector('#img-video');
  hr = document.querySelector('.select > ul.input-info > hr');
  opImg = document.querySelector('.img');
  opVideo = document.querySelector('.video');
  opImgVideo = document.querySelector('.img-video');

  // check browser status
  defaultLang();
  isMobile();
  iPhoneUseChrome();
  // en & vn default font family
  if (defaultLang() != "zh") {
    document.querySelector("body").setAttribute("class", "except-zh");
    deleteEnEmptyInfo();
  } else {
    document.querySelector("body").removeAttribute("except-zh");
    deleteZhEmptyInfo();
  }

  // build screen
  buildCategory();
  defaultCategory();
  buildList();
  buildDirection();
  mobileBtn();
  specBtn();
  designatedPage();
  let switchBtn = document.querySelector('#switch > .switch-btn > input[type=checkbox]');
  switchBtn.addEventListener('click', function() {
    currentPage = currentData.findIndex((el, index) => {
      let isSameGroup = el.switchGroup == currentData[currentPage].switchGroup;
      let isSameType = el.adType == currentData[currentPage].adType;
      return isSameGroup && isSameType && index != currentPage;
    });
    updatePage();
  });
  // toggleFullScreenBtn (Android Only)
  document.querySelector(".fullscreen").addEventListener('click', toggleFullScreen);
}

let href = location.href;
// as a token, to change website's language
function defaultLang() {
  let lang = getHrefLangString(href);
  if (lang == "zh") {
    return "zh";
  }
  if (lang == "vn") {
    return "vn";
  }
  return "en";
}

// to get language string from url parameter
function getHrefLangString() {
  if (href.split('?')[1] != undefined) {
    return href.split('?')[1].split("&")[0].toLowerCase();
  }
  return "en";
}

// to choose target category
function defaultCategory() {
  let category = getHrefFormatString();
  changeCategory(category);
}

// get format string from url parameter
function getHrefFormatString() {
  let currentIndex = 0;
  if(href.match("format")) {
    data.forEach((el, index) => {
      if (el.enName.replace(/\s*/g, "").toLowerCase() == href.split('?')[1].split("=")[1].split("&")[0].toLowerCase()) {
        currentIndex = index;
      }
    });
  }
  return currentIndex;
}

// get AdType string from url parameter
function getHrefAdTypeString() {
  let currentIndex = 0;
  if (href.match("type")) {
    currentData.forEach((el, index) => {
      let type = href.split('?')[1].split("=")[2].toLowerCase();
      let targetType = el.en.typeName.replace(/\s*/g, "").split("<span>").join("").split("</span>").join("").toLowerCase();
      if (type == targetType) {
        currentIndex = index;
      }
    });
  }
  return currentIndex;
}

function designatedPage() {
  let container = document.querySelector("#container");
  if(isMobile() == true && href.split('?')[1] != undefined && href.match("format")) {
    document.querySelector("body").style.gridTemplateAreas = "'main'";
    container.style.display = "grid";
    if (href.match("type")) {
      container.style.gridTemplateAreas = "'view'";
    } else {
      document.querySelector("#list-menu").style.display = "grid";
    }
    buildListMenu();
  }
}

// let screen visible
function iPhoneUseChrome() {
  let body = document.querySelector("body");
  let listMenu = document.querySelector("#list-menu");
  let view = document.querySelector("#view");
  let spec = document.querySelector("#spec");
  let specContent = document.querySelector(".spec-content");
  if (isMobile() == true && getMobileOperatingSystem() == "iOS" && isChrome() == "yes") {
    body.style.gridTemplateAreas = "'category' '.'";
    body.style.gridTemplateRows = "89% 11%";
    listMenu.style.gridTemplateRows = "11% auto 7.5% 47% 29%";
    view.style.gridTemplateRows = "11% 1fr 5% auto 5% 3fr 1fr 15% 3%";
    spec.style.height = "75vh";
    spec.style.top = "calc(50% - 35vh)";
    specContent.style.maxHeight = "68vh";
  }
}

// detect iOS's Chrome browser
function isChrome() {
  if(navigator.userAgent.match('CriOS')) {
    return "yes";
  }
  return "no";
}

// detect device's system
function getMobileOperatingSystem() {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }
  if (/android/i.test(userAgent)) {
    return "Android";
  }
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }
  return "unknown";
}

// record & change category
function changeCategory(num) {
  currentCategory = num;
  currentData = data[currentCategory].ads;
  updateCategory();
}

function deleteEmptyCategory() {
  data.filter((item) => item.ads != "");
}

function deleteZhEmptyInfo() {
  data.forEach((item) => {
    item.ads = item.ads.filter(ad => ad.zh.demoVideo != "");
  });
  data = data.filter((item) => item.ads != "");
}

function deleteEnEmptyInfo() {
  data.forEach((item) => {
    item.ads = item.ads.filter(ad => ad.en.demoVideo != "");
  });
  data = data.filter((item) => item.ads != "");
}

// let user can choose to display which AD format
function buildCategory() {
  data.forEach((item, index) => {
    let category = document.createElement('li');
    let img = document.createElement('img');
    let p = document.createElement('p');
    img.src = item.img;
    p.innerText = defaultLang() == "zh" ? item.name : item.enName;
    if (defaultLang() != "zh") {
      document.querySelectorAll('#category > ul > li > p').forEach(el => {
        el.style.fontWeight = "400";
      });
    }
    category.appendChild(img);
    category.appendChild(p);
    let body = document.querySelector("body");
    category.addEventListener("click", function() {
      if (isMobile() == true) {
        body.style.gridTemplateAreas = "'main'";  
        body.style.backgroundColor = "#F5F4F4";
        document.querySelector('#category').style.display = "none";
        document.querySelector('#container').style.display = "grid";
        document.querySelector('#list-menu').style.display = "grid";
      }
      document.querySelector('#disable-click').style.display = "none";
      document.querySelector('#spec').style.display = "none";
      document.querySelector('#list').style.pointerEvents = "auto";
      changeCategory(index);
      buildListMenu();
    });
    document.querySelector('#category > ul').appendChild(category);
  });
}

let format = "";
function recordFormat(category) {
  let lang = defaultLang();
  let formatName = category.enName.replace(/\s*/g, "");
  history.replaceState(`?${lang}&format=${formatName}`, '', `?${lang}&format=${formatName}`);
  format = `?${lang}&format=${formatName}`;
}

// user can choose which format Type to display, when device is desktop
function buildList() {
  document.querySelector(".imgBtn").addEventListener("click", function() {
    currentPage = currentData.findIndex((el) => {
      return el.adType == "img";
    });
    updatePage();
  });
  document.querySelector(".videoBtn").addEventListener("click", function() {
    currentPage = currentData.findIndex((el) => {
      return el.adType == "video";
    });
    updatePage();
  });
  document.querySelector(".img-videoBtn").addEventListener("click", function() {
    currentPage = currentData.findIndex((el) => {
      return el.adType == "img-video";
    });
    updatePage();
  });
}

// rules of list menu option, use to select format type
function buildListMenu() {
  let listMenu = document.querySelector('.select > ul.input-info');
  document.querySelector('.select > ul.input-info > input[type = radio]').checked = false;
  document.querySelectorAll('.select > ul.input-info > *').forEach((el) => {
    el.remove();
  });
  currentData.forEach((item) => {
    if (item.adType == 'img') {
      listMenu.appendChild(img);
      listMenu.appendChild(opImg);
    } else if (item.adType == 'video') {
      listMenu.appendChild(video);
      listMenu.appendChild(opVideo);
    } else {
      listMenu.appendChild(imgVideo);
      listMenu.appendChild(opImgVideo);
    }
  });
  document.querySelector('.select > ul.input-info > input:first-child').checked = true;
  let optionsLength = document.querySelectorAll('.select > ul.input-info > li').length;
  if (optionsLength >= 2) {
    listMenu.insertBefore(flag, listMenu.firstChild);
  }
  if (optionsLength >= 3) {
    listMenu.appendChild(hr);
  }
  flag.checked = true;
}

// to check other same format type's AD
function buildDirection() {
  let prev = document.querySelector("#prev");
  let next = document.querySelector("#next");
  prev.addEventListener("click", function() {
    currentPage = currentData.findIndex((el, index) => {
      let isSameType = el.adType == currentData[currentPage].adType;
      let isSameDevice = el.adDevice == currentData[currentPage].adDevice;
      let prevOne = el.switchGroup == parseInt(currentData[currentPage].switchGroup) - 1;
      let notCouple = index == currentData.length - 1 || el.switchGroup != currentData[index + 1].switchGroup;
      return (isSameType && isSameDevice && prevOne) || (isSameType && !isSameDevice && prevOne && notCouple);
    });
    updatePage();
  });
  next.addEventListener("click", function() {
    currentPage = currentData.findIndex((el, index) => {
      let isSameType = el.adType == currentData[currentPage].adType;
      let isSameDevice = el.adDevice == currentData[currentPage].adDevice;
      let nextOne = el.switchGroup == parseInt(currentData[currentPage].switchGroup) + 1;
      let notCouple = index == currentData.length - 1 || el.switchGroup != currentData[index + 1].switchGroup;
      return (isSameType && isSameDevice && nextOne) || (isSameType && !isSameDevice && nextOne && notCouple);
    });
    updatePage();
  });
}

// button to go prev or next page, when device is mobile
function mobileBtn() {
  let toCategory = document.querySelector('.to-category');
  let toList = document.querySelector('.to-list');
  let nextBtn = document.querySelector('.nextBtn');
  let container = document.querySelector('#container');
  let listMenu = document.querySelector('#list-menu');
  toCategory.addEventListener('click', function() {
    document.querySelector('body').style.gridTemplateAreas = "'category'";
    document.querySelector("body").style.backgroundColor = "white";
    document.querySelector('#category').style.display = "block";
    container.style.display = "none";
    listMenu.style.display = "none";
  });
  toList.addEventListener('click', function() {
    container.style.gridTemplateAreas = "'list-menu'";
    listMenu.style.display = "grid";
  });
  nextBtn.addEventListener('click', function() {
    container.style.gridTemplateAreas = "'view'";
    listMenu.style.display = "none";
    if (img.checked == true) {
      currentPage = currentData.findIndex((el) => {
        return el.adType == "img";
      });
      updatePage();
    } else if (video.checked == true) {
      currentPage = currentData.findIndex((el) => {
        return el.adType == "video";
      });
      updatePage();
    } else {
      currentPage = currentData.findIndex((el) => {
        return el.adType == "img-video";
      });
      updatePage();
    }
  });
  document.querySelectorAll("input[name=adtype]").forEach(el => {
    el.addEventListener('change', e => {
      document.querySelector("#flag").checked = true;
    })
  });
}

// let user know which category he click and display the category's format type
function updateCategory() {
  // display the chosen one!
  document.querySelectorAll("#category > ul > li").forEach((btn, index) => {
    index == currentCategory ? btn.classList.add("active") : btn.classList.remove("active");
    recordFormat(data[currentCategory]);
  });
  // place in format type all his have
  document.querySelectorAll("#list > ul > li").forEach((btn) => {
    btn.style.display = "none";
  });
  currentData.forEach((item) => {
    let btn = document.querySelector(`.${item.adType}Btn`);
    btn.style.display = "flex";
  });
  currentPage = getHrefAdTypeString();
  // console.log(`Page: ${currentPage}`);
  updatePage();
}

// let user know which format type is select and display the demo video
function updatePage() {
  // which format type is select
  document.querySelectorAll("#list > ul >li").forEach((btn) => {
    btn.classList.remove("active");
  });
  document.querySelector(`.${currentData[currentPage].adType}Btn`).classList.add("active");
  // renew screen
  changeLanguage();
  changeShow();
  directionStyle();
  displayViewDemoBtn();
  displayAlertCard();
  buildSpec();
  recordType();
  // show AD type name
  let type = document.querySelector(".type");
  type.innerHTML = currentData[currentPage][defaultLang()].typeName;
  if (defaultLang() != "zh") {
    type.style.fontWeight = "500";
  }
  // switch font
  document.querySelectorAll("#switch > p").forEach(el => {
    if (defaultLang() != "zh") {
      el.style.fontWeight = "400";
    }
  });
  // show format type(at list menu page)
  let name = document.querySelector(".name");
  name.innerText = defaultLang() == "zh" ? data[currentCategory].name : data[currentCategory].enName;
  if (defaultLang() != "zh") {
    name.style.fontWeight = "300";
  }

  // when user use Android mobile (no need)
  // if (isMobile() == true) {
  //   if (getMobileOperatingSystem() == "Android" || getMobileOperatingSystem() == "Windows Phone") {
  //     document.querySelector(".fullscreen").style.display = "block";
  //   }
  // }
}

function recordType() {
  let adType = currentData[currentPage]["en"].typeName.replace(/\s*/g, "").split("<span>").join("").split("</span>").join("");
  if (format != "") {
    history.replaceState(`${format}&type=${adType}`, '', `${format}&type=${adType}`);
  }
}

// for different language user
function changeLanguage() {
  document.querySelectorAll(".en").forEach(el => {
    el.style.display = defaultLang() == "en" ? "inline-block" : "none";
  });
  document.querySelectorAll(".vn").forEach(el => {
    el.style.display = defaultLang() == "vn" ? "inline-block" : "none";
  });
  document.querySelectorAll(".zh").forEach(el => {
    el.style.display = defaultLang() == "zh" ? "inline-block" : "none";
  });
}

// change demo video when click switch button
function changeShow() {
  document.querySelector("#demo > .mobile").style.display = currentData[currentPage].adDevice == "mobile" ? "block" : "none";
  document.querySelector(".mobile > video").setAttribute('src', currentData[currentPage][defaultLang()].demoVideo);
  document.querySelector("#demo > .desktop").style.display = currentData[currentPage].adDevice == "desktop" ? "block" : "none";
  document.querySelector(".desktop > video").setAttribute('src', currentData[currentPage][defaultLang()].demoVideo);
  let switchBtn = document.querySelector("#switch");
  switchBtn.style.display = currentData.findIndex((el, index) => {
    let isSameType = el.adType == currentData[currentPage].adType;
    let isSameGroup = el.switchGroup == currentData[currentPage].switchGroup;
    let notMe = index != currentPage;
    return isSameType && isSameGroup && notMe;
  }) != -1 ? "flex" : "none";
  let switchChecked = document.querySelector("#switch > .switch-btn > input[type=checkbox]");
  switchChecked.checked = currentData[currentPage].adDevice == "desktop" ? true : false;
}

// change prev & next btn style
function directionStyle() {
  let isFirst = currentData[currentPage].switchGroup == 1;
  let isLast = currentData.findIndex((el) => {
    let isSameType = el.adType == currentData[currentPage].adType;
    let nextOne = el.switchGroup == parseInt(currentData[currentPage].switchGroup) + 1;
    return isSameType && nextOne;
  }) == -1;
  let prev = document.querySelector("#prev");
  prev.style.display = isFirst && isLast ? "none" : "block";
  prev.style.opacity = isFirst ? ".5" : "1";
  prev.style.cursor = isFirst ? "auto" : "pointer";
  prev.style.pointerEvents = isFirst ? "none" : "auto";
  let next = document.querySelector("#next");
  next.style.display = isFirst && isLast ? "none" : "block";
  next.style.opacity = isLast ? ".5" : "1";
  next.style.cursor = isLast ? "auto" : "pointer";
  next.style.pointerEvents = isLast ? "none" : "auto";
}

// to decide "view demo" button should or not display
function displayViewDemoBtn() {
  let viewDemoBtn = document.querySelector("#view-demoBtn");
  viewDemoBtn.style.display = isMobile() == true && currentData[currentPage].adDevice == "desktop" || currentData[currentPage][defaultLang()].galleryLink == "" ? "none" : "flex";
  viewDemoBtn.setAttribute('href', currentData[currentPage][defaultLang()].galleryLink);
}

// when use mobile to display desktop demo page
function displayAlertCard() {
  let alertCard = document.querySelector("#alertCard");
  alertCard.style.display = isMobile() == true && currentData[currentPage].adDevice == "desktop" && currentData[currentPage][defaultLang()].galleryLink != "" ? "flex" : "none";
  let alertCardText = document.querySelector("#alertCard > .alert-text");
  if (defaultLang() != "zh") {
    alertCardText.style.fontWeight = "300";
    alertCardText.style.width = "80%";
    document.querySelector("#alertCard").style.height = "28vw";
  }
}

// to control spec open & close
function specBtn() {
  let guideBtn = document.querySelector('#guide');
  let closeBtn = document.querySelector('.close');
  let disableClick = document.querySelector('#disable-click');
  let spec = document.querySelector('#spec');
  guideBtn.addEventListener('click', function() {
    disableClick.style.display = "block";
    spec.style.display = "flex";
    document.querySelector('#list').style.pointerEvents = "none";
    if (isMobile() == true) {
      document.querySelector("body").style.backgroundColor = "#44444490";
    }
    updatePage();
  });
  closeBtn.addEventListener('click', function() {
    disableClick.style.display = "none";
    spec.style.display = "none";
    document.querySelector('#list').style.pointerEvents = "auto";
    if (isMobile() == true) {
      document.querySelector("body").style.backgroundColor = "#F5F4F4";
    }
    updatePage();
  });
}

// spec content
function buildSpec() {
  specLang(defaultLang());
  if (defaultLang() != "zh") {
    let typeName = document.querySelector(".type-name");
    typeName.style.fontWeight = "500";
    document.querySelectorAll('#spec > .spec-content > .spec-style > p').forEach(el => {
      el.style.fontWeight = "300";
      if (isMobile() == true) {
        el.style.fontWeight = "400";
        el.style.fontSize = "1.1rem";
      }
    });
  }
}

// place url designated language
function specLang(lang) {
  document.querySelector(".type-name").innerHTML = currentData[currentPage][lang].typeName;
  document.querySelector(".device").innerText = currentData[currentPage][lang].device;
  document.querySelector(".safe").innerText = currentData[currentPage][lang].safe;
  document.querySelector(".link").innerText = currentData[currentPage][lang].link;
  if (currentData[currentPage][lang].material.includes("</span>")) {
    document.querySelector(".material").innerHTML = currentData[currentPage][lang].material;
    document.querySelector(".material > .desktop").style.display = isMobile() ? "none" : "block";
    document.querySelector(".material > .mobile").style.display = isMobile() ? "block" : "none";
  } else {
    document.querySelector(".material").innerText = currentData[currentPage][lang].material;
  }
  document.querySelector(".note-title").style.display = currentData[currentPage][lang].note == "" ? "none" : "block";
  document.querySelector(".note").innerText = currentData[currentPage][lang].note;
  document.querySelector(".memo-title").style.display = currentData[currentPage][lang].memo == "" ? "none" : "block";
  document.querySelector(".memo").innerText = currentData[currentPage][lang].memo;
}

// can let user use fullscreen (Android mobile Only)
function toggleFullScreen() {
  let doc = window.document;
  let docEl = doc.documentElement;

  let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
  let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

  if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    requestFullScreen.call(docEl);
  }
  else {
    cancelFullScreen.call(doc);
  }
}
